<template>
  <div>
    <div ref="detail" class="invite-detail" :class="{'scrolled': this.scrolled, 'show-popup': this.showPopup || this.showCheckPopup, 'show-modal': this.modalTip}" v-on:scroll.passive="handleScroll">
      <div class="header" :class="{'posiFix': this.scrolled,'operationDele': !this.isOwner}">
        <div class="header-inner">
          <div class="row top" :class="{'posiFix': this.scrolled}">
            <h2 class=" col-9 title">{{this.inviteData.priVisitorName}} {{this.inviteData.typeName}} {{this.inviteData.areaName}}
            </h2>
            <div class="col-3">
              <!-- <router-link to="/external" class="go-back"><i class="iconfont icon-close"></i></router-link> -->
            </div>
          </div>
          <div class="header-content" v-if="this.inviteData">
            <div class="dock-number" v-if="this.inviteData.dockNumber">{{$t('DockNumber')}}：  {{this.inviteData.dockNumber}}</div>
            <div class="time">{{$t('visitTime')}}  {{this.inviteData.startDay}} - {{this.inviteData.endDay}}</div>
            <div class="apply-time" v-if="this.inviteData.isCarrierTicket">{{$t('ExpectedVisitPeriod')}}：  {{this.inviteData.schedule}}</div>
            <div class="business">{{$t('VisitType')}}  {{this.inviteData.typeName}}</div>
            <div class="business">{{$t('VisitArea')}}  {{this.inviteData.areaName}}</div>
            <div class="bottler-order" v-if="this.inviteData.bottleOrderNumberList && this.inviteData.bottleOrderNumberList.length && this.inviteData.isCarrierTicket">{{$t('bottler')}}/{{$t('OrderNumber')}}：    
              <span v-for="(item, index) in this.inviteData.bottleOrderNumberList" :key="index">{{item.bottleName}}<span v-if="item.orderNumber">/</span>{{item.orderNumber}} </span>
            </div>
            <div class="apply-status" v-if="this.inviteData.isCarrierTicket">{{$t('ApplyStatus')}}：  {{this.inviteData.checkStatusText}}</div>
            <div class="training" v-show="this.lessonList !='' ">{{$t('Course')}}  {{this.lessonList}}</div>
            <div class="creater">{{$t('creator')}}  {{this.inviteData.creatorName}}</div>
            <transition name="slide-fade">
              <div class="other">
                <div class="area" v-if="this.inviteData.visitAreaDetail">{{$t('accessSubdivisionArea')}}  {{this.inviteData.visitAreaDetail}}</div>
                <div class="purpose" v-if="this.inviteData.visitReason">{{$t('visitPurpose')}}  {{this.inviteData.visitReason}}</div>
              </div>
            </transition>
            <div class="operation row" v-show="this.isOwner" :class="{'operationBtn': this.visitReason}">
              <div class="delete" @click="deleteInvite">{{$t('delete')}}</div>
              <div class="modify" @click="modifyInvite">{{$t('modify')}}</div>
            </div>
            <div class="forwardingOperation row" v-if="this.showAddInvisitor && this.canForward" @click="forwardingOperation"><span>{{$t('forward')}}</span></div>
          </div>
        </div>
        <div class="header-bg"></div>
      </div>
      <transition name="fade">
        <div class="reason" v-show="this.showPopup">
          <div class="reson-inner">
            <i class="iconfont icon-close" @click="showPopup = !showPopup"></i>
            <h4>{{ $t('reason') }}</h4>
            <div class="row reson-option" v-if="this.isOwner">
              <div class="col-4">{{ $t('reason') }}</div>
              <div class="col-8 refuse-reson">
                <select @change="selectVal" v-model="selectReason">
                  <option>{{ $t('chooseTheReason') }}</option>
                  <option :key="index" :tab='item.id' v-for='(item, index) in this.RejectType'>{{item.content}}</option>
                </select>
              </div>
            </div>
            <p>{{ $t('description') }}<span v-show="this.isOwner">{{ $t('optional') }}</span></p>
            <div class="form-group">
              <textarea rows="3" :placeholder="$t('fillDetailsHere')" v-model="textareaAll"></textarea>
            </div>
            <div class="form-action" v-if="this.isOwner">
              <button class="btn btn-gradient" @click="commitReason">{{ $t('submit') }}</button>
            </div>
            <div class="form-action" v-if="!this.isOwner && this.isCheckOwner">
              <button class="btn btn-gradient" @click="commitAllReason">{{ $t('submit') }}</button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="reason" v-if="this.inviteGoodsList.length" v-show="this.showCheckPopup">
          <div class="reson-inner">
            <i class="iconfont icon-close" @click="closeCheckModal"></i>
            <h4>{{ $t('reason') }}</h4>
            <p>{{ $t('description') }}</p>
            <div class="form-group">
              <textarea rows="3" :placeholder="$t('fillDetailsHere')" v-model="textareaCheckDetail"></textarea>
            </div>
            <div class="form-action">
              <button class="btn btn-gradient" @click="commitCheckReason">
                {{ $t('submit') }}
              </button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="tip" v-show="this.modalTip">
          <div class="tip-inner">
            <div class="tip-text">{{modalTipText}}</div>
            <div class="comfirmBtn" @click="modalTip = !modalTip">{{$t('confirm')}}</div>
          </div>
        </div>
      </transition>
    </div>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>
<script>
import newWareHouse from '@/components/newWareHouse.vue';
import tipModal from '@/components/tipModal.vue';
import newInvisit from '@/components/newInvisit.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  getOverviewInfo,
  getInvitationInfo,
  getInvitationSchedule,
  getRejectReasons,
  materialReview,
  checkPassOrReject,
  sendRemind,
  goodsListCheckPassOrReject,
  getInvitationInfoForEdit,
} from '@/utils/api';
import { checkNested } from '@/utils/utils';
import photoSwipe from '@/components/photoSwipe.vue';
import { setupLang } from '@/locales';
import { setLanguage } from '@/utils/api';
export default {
  name: 'InviteDetail',
  components: {
    newWareHouse,
    tipModal,
    newInvisit,
    Loading,
    photoSwipe,
  },
  data() {
    return {
      showLanguage: false,
      locale: window.localStorage.getItem('localeLanguage'),
      phone: '',
      showOther: false,
      scrolled: false,
      inviteData: {},
      userType: 'warehouse',
      isTicketOwner: false,
      showPopup: false,
      modalTip: false,
      modalTipText: '',
      textareaAll: '',
      approverList: [],
      ccNameList: '',
      gmListShow: false,
      gmList: [],
      visitReason: false,
      isOwner: false,
      isCheckOwner: false,
      lessonList: '',
      routId: 0,
      showCheckPopup: false,
      goodsListId: '',
      textareaCheckDetail: '',
      checkList: [],
      visitorData: [],
      visitorListArray: [],
      progress: [],
      RejectType: [],
      DeleteText: '',
      showVisitorHouse: true,
      newWareHouseShow: false,
      showComfirmDelete: false,
      deleteInvitationId: '',
      inviteGoodsList: [],
      goodsImages: [],
      currentGoods: {},
      approverId: '',
      isGoodsListChecker: false,
      lookImgs: false,
      // modify invite
      isLoading: false,
      isModifyInviteShow: false,
      inviteInfo: null,
      photoSwipeModal: false,
      showLoginOut: false,
      loginOut: '',
      showAddInvisitor: false,
      canForward: false,
    };
  },
  created() {
  },
  methods: {
    handleScroll() {
      // console.log(this.$refs.detail);
      if (document.documentElement.clientHeight < document.body.clientHeight + 1) {
        this.scrolled = this.$refs.detail.scrollTop != 0;
      }
    },
    loadData(data, ifEnable, canForward) {
      if (data) {
        this.inviteData = data;
      }
      if (this.inviteData.lessonName) {
        const lessonName = this.inviteData.lessonName;
        this.lessonList = lessonName.join('/');
      }
      this.showAddInvisitor = ifEnable;
      this.canForward = canForward;
    },
    onLocaleChange: function(event) {
      const lang = event.target.value;
      const culture = lang === 'en' ? 'en-US' : 'zh-CN';

      // Locale side
      setupLang(lang);

      // Backend side
      setLanguage(culture).then((res) => {
        window.location.reload();
      });
    },
    onLogoOut() {

    },
    changeStatus(status, checkList) {
      this.showPopup = status;
      this.checkList = checkList;
      // console.log(checkList);
    },
    popupTipModal(status, txt) {
      this.modalTip = status;
      this.modalTipText = txt;
    },
    popupGmModal(status, txt) {
      this.showPopup = status;
    },
    selectVal(e) {
      const getValue = e.target.value;
      const getIndex = e.target.tab;
      if (this.textareaAll.indexOf(getValue) != -1 || getValue.indexOf(this.$t('choose')) != -1) {
        this.textareaAll = `${this.textareaAll}`;
      } else {
        this.textareaAll = `${this.textareaAll + getValue},`;
      }
    },
    commitReason() {
      if (this.textareaAll != '' || this.selectReason != this.$t('chooseTheReason')) {
        this.textareaAll = this.textareaAll.substring(0, this.textareaAll.lastIndexOf(','));
        let getReason = {};
        if (this.textareaAll === '') {
          getReason = {
            invitationId: this.routId,
            idList: this.checkList,
            isPass: 0,
            reason: this.selectReason,
          };
        } else {
          getReason = {
            invitationId: this.routId,
            idList: this.checkList,
            isPass: 0,
            reason: this.textareaAll,
          };
        }
        // console.log(getReason);
        materialReview(getReason).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.status === 1) {
              window.location.reload();
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.model;
            }
          }
        });
      } else {
        this.modalTip = true;
        this.modalTipText = this.$t('pleaseFillReason');
      }
    },
    commitAllReason() {
      if (this.textareaAll != '') {
        const getReason = {
          id: this.routId,
          isPass: false,
          reason: this.textareaAll,
        };
        checkPassOrReject(getReason).then((res) => {
          if (res.data.content.status === 1) {
            window.location.reload();
          } else {
            this.modalTip = true;
            this.modalTipText = res.data.content.message;
          }
        });
      } else {
        this.modalTip = true;
        this.modalTipText = this.$t('pleaseFillReason');
      }
    },
    deleteInvite() {
      const invitationId = this.routId;
      if (invitationId) {
        this.goodsListId = '';
        this.deleteInvitationId = 'deleteInvitationId';
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'deleteInvitationId',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      }
    },
    closeNewWarehouse(status) {
      this.newWareHouseShow = status;
    },
    closeModal(status) {
      this.showComfirmDelete = status;
    },
    approveAllListModal(status, txt) {
      this.modalTip = status;
      this.modalTipText = txt;
    },
    remindApproval(e) {
      const ApproverId = e.target.dataset.value;
      const statusId = e.target.dataset.status;
      if (statusId == 1) {
        this.deleteInvitationId = 'remindApproval';
        this.approverId = ApproverId;
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'remindApproval',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      } else {
        sendRemind(ApproverId).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.status === 1) {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
            }
          }
        });
      }
    },
    deleteCheckDetail(e) {
      const GoodsListId = e.target.dataset.value;
      this.invitationId = this.routId;
      this.goodsListId = GoodsListId;
      if (this.invitationId && this.goodsListId) {
        this.deleteInvitationId = 'deleteCheckGoods';
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'deleteCheckGoods',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      }
    },
    rejectCheckDetail(e) {
      if (this.inviteGoodsList.length) {
        this.showCheckPopup = true;
        this.goodsListId = e.target.dataset.value;
      }
    },
    commitCheckReason() {
      // console.log(this.goodsListId);
      const goodsListId = this.goodsListId;
      const InvitationId = this.routId;
      if (this.textareaCheckDetail != '') {
        const getGoodObj = {
          goodsListId,
          ticketId: InvitationId,
          isPass: false,
          reason: this.textareaCheckDetail,
        };
        goodsListCheckPassOrReject(getGoodObj).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.status === 1) {
              window.location.reload();
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
            }
          }
        });
      } else {
        this.modalTip = true;
        this.modalTipText = this.$t('pleaseFillReason');
      }
    },
    agreeCheckDetail(e) {
      const goodsListId = e.target.dataset.value;
      // console.log(e);
      // console.log(goodsListId);
      const InvitationId = this.routId;
      const getGoodObj = {
        goodsListId,
        ticketId: InvitationId,
        isPass: true,
        reason: '',
      };
      goodsListCheckPassOrReject(getGoodObj).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          if (res.data.content.status == 1) {
            window.location.reload();
          } else {
            this.modalTip = true;
            this.modalTipText = res.data.content.message;
          }
        }
      });
    },
    closeCheckModal() {
      this.showCheckPopup = false;
      this.textareaCheckDetail = '';
    },
    showLookImgs(status) {
      this.lookImgs = status;
    },
    modifyInvite() {
      this.isModifyInviteShow = true;
      getInvitationInfoForEdit(this.routId).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          // console.log(res.data.content.model);
          this.inviteInfo = res.data.content.model;
        }
      });
    },
    // TODO: this event's name is quite strange
    handleGetMessage() {
      this.isModifyInviteShow = false;
    },
    closePhoto() {
      this.photoSwipeModal = false;
    },
    forwardingOperation() {
      this.$emit('forWaringmodalShow', true);
    }
  }
};

</script>
<style lang="scss" scoped>
@import "../../scss/variables.scss";

.btn {

  &:focus,
  &:hover {
    box-shadow: none;
  }
}

.btn-default {
  border: 1px solid #929292;
  color: #9b9b9b;
}

.btn-red {
  color: #e42029;
  border: 1px solid #e42029;
}

.btn-gradient {
  color: #fff;
  background-image: linear-gradient(73deg, #f36443, #e42029);

  &:hover {
    color: #fff;
  }
}

.scrolled {

  .header:before,
  .header-bg {
    display: none;
  }

  .header {
    .title {
      margin-bottom: 0;
    }
  }
}

.operationDele {
  .header {
    padding-bottom: 10px;
  }
}

.show-popup,
.show-modal,
.show-status {
  height: 100vh;
  overflow: hidden;
  color: #4a4a4a;

  .reason,
  .tip {
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.4);

    .tip-inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 270px;
      border-radius: 12px;
      background-color: #fcfcfc;
      text-align: center;

      .tip-text {
        padding: 20px 0 15px;
        font-size: 17px;
        color: #4a4a4a;
      }

      .comfirmBtn {
        padding: 12px;
        font-size: 17px;
        color: #e42029;
      }
    }

    .icon-close {
      position: absolute;
      top: 10px;
      right: 5%;
      z-index: 10;
      font-size: 22px;
    }
  }

  .reson-inner {
    h4 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    p {
      font-size: 13px;
      margin-bottom: 5px;
    }

    .reson-option {
      margin-bottom: 20px;
    }

    .refuse-reson {
      text-align: right;

      select {
        color: #929292;
        appearance: none;
        border: none;
        outline: none;
        padding-right: 9px;
        background: url('../../assets/images/arrow-copy.png') no-repeat right center;
        background-size: 7px;
      }
    }

    textarea {
      width: 100%;
      height: 175px;
      border: none;
      background: #f0f0f0;
      padding: 8px;
      font-size: 13px;
    }

    .form-group {
      margin-bottom: 25px;
    }

    .form-action {
      margin-bottom: 20px;
    }

    .btn {
      width: 100%;
    }

    .btn:hover {
      color: inherit;
    }
  }
}

.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.visit-show {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 15;
  background: rgba(0, 0, 0, 0.4);

  .invisitListContent {
    position: absolute;
    bottom: 0;
  }
}

.invite-detail {
  width: 369px;
  max-height: 345px;
  float: left;
  .forwardingOperation {
    float: right;
    margin-right: 30px;
    cursor: pointer;

    span {
      padding: 5px 20px;
      border: 1px solid #fff;
      border-radius: 17px;
      cursor: pointer;
    }
  }
  @include respond-to('sm-max') {
    width: 100%;
    background: #fff;
    overflow: hidden;
    float: none;

    .header {
      height: auto;
      background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
      position: relative;
      z-index: 9;
      color: #fff;
      font-size: 13px;
      border-radius: 0;
      padding-bottom: 40px;

      &.posiFix {
        z-index: 11;
      }

      &.operationDele {
        padding-bottom: 50px;
      }

      .header-inner {
        padding: 15px;
        position: relative;
        z-index: 9;
        padding-right: 0;

        .top {
          &>div:last-child {
            text-align: right;
            padding-right: 30px;
          }
        }

        .posiFix {
          position: fixed;
          top: 0;
          z-index: 11;
          width: 100%;
          padding: 10px 0;
          background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
          align-items: center;
        }
      }

      .title {
        font-size: 16px;
        margin-bottom: 15px;
        font-weight: bold;
      }

      &:before {
        content: '';
        width: 110px;
        height: 110px;
        border-radius: 0 0 0 110px;
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        border-left: 30px solid #fff;
        border-bottom: 30px solid #fff;
        opacity: 0.12;
      }

      .status-send-msg {
        .status {
          font-size: 13px;

          i {
            margin-right: 5px;
            font-size: 13px;
          }
        }

        .send-msg {
          font-size: 12px;
          text-align: right;

          span {
            border-bottom: 1px solid #fff;
          }
        }
      }

      .approver-copier {
        margin: 0;

        &>div:first-child {
          width: 130px;
        }

        .approver {
          padding: 0;

          span {
            border: 1px solid #fff;
            margin-left: 10px;
            padding: 1px;
            font-size: 11px;

            i {
              font-size: 12px;
            }
          }
        }

        .remind {
          text-align: right;

          span {
            cursor: pointer;
            padding-bottom: 2px;
            border-bottom: 1px solid #fff;
            font-size: 11px;
          }
        }
      }

      .member {
        &>div {
          padding: 0 15px;
        }

        strong {
          font-size: 15px;
          margin-right: 5px;
        }
      }

      .forwardingOperation {
        float: right;
        margin-right: 30px;
        cursor: pointer;

        span {
          padding: 5px 20px;
          border: 1px solid #fff;
          border-radius: 17px;
          cursor: pointer;
        }
      }

      .operation {
        float: right;
        margin-top: 10px;

        &.operationBtn {
          margin-top: -8px;
        }

        div {
          cursor: pointer;
          border-radius: 17px;
          border: solid 1px #ffffff;
          padding: 3px 20px;
          margin-right: 10px;
        }

        &>div:last-child {
          margin-right: 25px;
        }
      }
    }

    .go-back {
      color: #fff;

      .iconfont {
        font-size: 22px;
      }
    }

    .handle-group {
      margin-top: 10px;
    }

    .btn-toggle {
      float: left;

      i {
        font-size: 12px;
        display: inline-block;
        transform: scale(0.5, 0.5);
        margin-right: -2px;
      }

      span {
        display: block;
        padding: 0 5px 0 0;
        font-size: 11px;
        background: rgba(255, 255, 255, .35);
        line-height: 20px;
        border-radius: 10px;
      }
    }

    .btn-edit {
      font-size: 13px;
      line-height: 28px;
      padding: 0 20px;
      border-radius: 15px;
      border: 1px solid #fff;
      float: right;

      i {
        margin-right: 5px;
        display: inline-block;
      }
    }

    .header-bg {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      bottom: 0;
      z-index: 1;

      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.06;
      }

      &:before {
        width: 80px;
        height: 80px;
        border-radius: 0 80px 0 0;
        border-right: 30px solid #fff;
        border-top: 30px solid #fff;
      }

      &:after {
        width: 150px;
        height: 150px;
        border-radius: 0 150px 0 0;
        border-right: 30px solid #fff;
        border-top: 30px solid #fff;
      }
    }

    .content {
      background-color: #fff;
      border-radius: 10px 10px 0 0;
      //padding-top: 20px;
      width: 100%;
      margin-top: -10px;
      position: relative;
      z-index: 10;

      &.lookImgs {
        z-index: 12;
      }
    }
  }

  @include respond-to('ml') {
    background: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    float: none;
    width: 100%;

    .header {
      height: auto;
      background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
      position: relative;
      z-index: 9;
      color: #fff;
      font-size: 13px;
      border-radius: 0;
      padding-bottom: 40px;

      &.posiFix {
        z-index: 11;
      }

      &.operationDele {
        padding-bottom: 50px;
      }

      .header-inner {
        padding: 15px;
        position: relative;
        z-index: 9;
        padding-right: 0;

        .top {
          &>div:last-child {
            text-align: right;
            padding-right: 30px;
          }
        }

        .posiFix {
          position: fixed;
          top: 0;
          z-index: 11;
          width: 100%;
          padding: 10px 0;
          background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
          align-items: center;
        }
      }

      .title {
        font-size: 16px;
        margin-bottom: 15px;
        font-weight: bold;
      }

      &:before {
        content: '';
        width: 110px;
        height: 110px;
        border-radius: 0 0 0 110px;
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        border-left: 30px solid #fff;
        border-bottom: 30px solid #fff;
        opacity: 0.12;
      }

      .status-send-msg {
        .status {
          font-size: 13px;

          i {
            margin-right: 5px;
            font-size: 13px;
          }
        }

        .send-msg {
          font-size: 12px;
          text-align: right;

          span {
            border-bottom: 1px solid #fff;
          }
        }
      }

      .approver-copier {
        margin: 0;

        &>div:first-child {
          width: 130px;
        }

        .approver {
          padding: 0;

          span {
            border: 1px solid #fff;
            margin-left: 10px;
            padding: 1px;
            font-size: 11px;

            i {
              font-size: 12px;
            }
          }
        }

        .remind {
          text-align: right;

          span {
            cursor: pointer;
            padding-bottom: 2px;
            border-bottom: 1px solid #fff;
            font-size: 11px;
          }
        }
      }

      .member {
        &>div {
          padding: 0 15px;
        }

        strong {
          font-size: 15px;
          margin-right: 5px;
        }
      }

      .forwardingOperation {
        float: right;
        margin-right: 30px;
        cursor: pointer;
        span {
          padding: 5px 20px;
          border: 1px solid #fff;
          border-radius: 17px;
        }
      }

      .operation {
        float: right;
        margin-top: 10px;

        &.operationBtn {
          margin-top: -8px;
        }

        div {
          cursor: pointer;
          border-radius: 17px;
          border: solid 1px #ffffff;
          padding: 3px 20px;
          margin-right: 10px;
        }

        &>div:last-child {
          margin-right: 25px;
        }
      }
    }

    .go-back {
      color: #fff;

      .iconfont {
        font-size: 22px;
      }
    }

    .handle-group {
      margin-top: 10px;
    }

    .btn-toggle {
      float: left;

      i {
        font-size: 12px;
        display: inline-block;
        transform: scale(0.5, 0.5);
        margin-right: -2px;
      }

      span {
        display: block;
        padding: 0 5px 0 0;
        font-size: 11px;
        background: rgba(255, 255, 255, .35);
        line-height: 20px;
        border-radius: 10px;
      }
    }

    .btn-edit {
      font-size: 13px;
      line-height: 28px;
      padding: 0 20px;
      border-radius: 15px;
      border: 1px solid #fff;
      float: right;

      i {
        margin-right: 5px;
        display: inline-block;
      }
    }

    .header-bg {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      bottom: 0;
      z-index: 1;

      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.06;
      }

      &:before {
        width: 80px;
        height: 80px;
        border-radius: 0 80px 0 0;
        border-right: 30px solid #fff;
        border-top: 30px solid #fff;
      }

      &:after {
        width: 150px;
        height: 150px;
        border-radius: 0 150px 0 0;
        border-right: 30px solid #fff;
        border-top: 30px solid #fff;
      }
    }

    .content {
      background-color: #fff;
      border-radius: 10px 10px 0 0;
      //padding-top: 20px;
      width: 100%;
      margin-top: -10px;
      position: relative;
      z-index: 10;

      &.lookImgs {
        z-index: 12;
      }
    }
  }
}

</style>
